<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import { findConpanyConfig } from '../../../../../../api/Draftgeneration.js';
export default {
	name: '',
	components: {},
	data: function() {
		return {
			headDataI: getdata().headDataI,
			delCells: [],
			option: [
				{
					value: '0',
					label: '请选择'
				},
				{
					value: '0035049901',
					label: '在职职工总数30人（含）以下暂免征收残保金'
				},
				{
					value: '0035013601',
					label: '残保金调整为分档征收'
				}
			],
			start: '',
			stop: ''
		};
	},
	props: {
		params: {
			type: Object,
			default: {}
		},
		showpz: {
			type: Boolean,
			default: false
		},
		tableDataI: {
			type: Array,
			default: []
		},
		tableDataII: {
			type: Object,
			default: {}
		},
		headobj: {
			type: Object,
			default: {}
		},
		choosecellCode: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: ''
		},
		toseeUpdate: {
			type: Boolean,
			default: false
		},
		start: {
			type: String,
			default: ''
		},
		stop: {
			type: String,
			default: ''
		}
	},
	created() {
		console.log(this.tableDataI)
		console.log(this.tableDataII)
	},
	methods: {
		inputblur(e) {
			this.$emit('inputblur', e);
		},
		forhover(table, colum, index) {
			this.$emit('forhover', table, colum, index);
		},
		zcsclick(e) {
			this.$emit('zcsclick', e);
		},
		headchange() {
			this.$emit('headchange', this.headobj);
		},
		fordelete(index) {
			if (this.tableDataI.length < 3) {
				return false;
			}
			if (this.$notemptyandnull(this.tableDataI[index]['cbj_0_x_1'].id)) {
				this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
			}
			this.tableDataI.splice(index, 1);
			this.$emit('delCellsCode', this.delCells);
		},
		selectchange(e) {
			this.option.map(item => {
				if (e.cbj_0_x_10.cellVal == item.value) {
					e.cbj_0_x_10a.cellVal = item.label;
				}
			});
		},
		foraddhang() {
			let time = new Date();
			let endobj = this.tableDataI[this.tableDataI.length - 1];
			this.tableDataI.pop();
			this.tableDataI.push({
				cbj_0_x_1: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_1',
					cellType: '0',
					cellVal: this.tableDataI.length + 1,
					updateDesc: '',
					map: {}
				},
				cbj_0_x_2: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_2',
					cellType: '0',
					cellVal: this.headobj .shuikssqq,
					updateDesc: '',
					map: {}
				},
				cbj_0_x_3: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_3',
					cellType: '0',
					cellVal: this.headobj .shuikssqz,
					updateDesc: '',
					map: {}
				},
				cbj_0_x_4: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_4',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_5: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_5',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_6: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_6',
					cellType: '0',
					cellVal: '1.5',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_7: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_7',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_8: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_8',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_9: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_9',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_10: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_10',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_10a: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_10a',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_11: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_11',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_12: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_12',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				},
				cbj_0_x_13: {
					cellCode: 'cbj_0_' + (parseFloat(this.tableDataI.length) + 1) + '_13',
					cellType: '0',
					cellVal: '',
					updateDesc: '',
					map: {}
				}
			});
			this.tableDataI.push(endobj);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('../../SmallScaleVAT/index.less');
</style>
